import { render, staticRenderFns } from "./ApproveInput.vue?vue&type=template&id=2e5b6435&scoped=true&"
import script from "./ApproveInput.vue?vue&type=script&lang=js&"
export * from "./ApproveInput.vue?vue&type=script&lang=js&"
import style0 from "./ApproveInput.vue?vue&type=style&index=0&id=2e5b6435&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b6435",
  null
  
)

export default component.exports